import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { docStatusTone } from '../lib/docs';
import { money } from '../lib/format';
import { useSession } from '../lib/session';
import '../styles/deals.css';
import '../styles/crm.css';

interface Contract {
  id: string;
  number: string;
  title: string | null;
  counterpartyName: string | null;
  status: string;
  statusLabel: string;
  totalMinor: number;
  paidMinor: number;
  currency: string;
}

export function Projects() {
  const { company } = useSession();
  const nav = useNavigate();
  const [rows, setRows] = useState<Contract[] | null>(null);

  useEffect(() => {
    if (!company) return;
    setRows(null);
    api.get<Contract[]>('/documents?types=contract').then(setRows).catch(() => setRows([]));
  }, [company]);

  return (
    <main className="main">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">Operaciones</span>
          <h1 className="h1">Proyectos e hitos</h1>
          <p className="page-head__sub">Each contract is a project. Progress measures how much of its total amount has been collected through invoiced milestones.</p>
        </div>
      </div>

      <div className="card">
        {!rows && <div className="empty">Loading…</div>}
        {rows && rows.length === 0 && <div className="empty">No projects (contracts) yet.</div>}
        {rows && rows.map((c) => {
          const pct = c.totalMinor > 0 ? Math.min(100, Math.round((c.paidMinor / c.totalMinor) * 100)) : 0;
          return (
            <button key={c.id} className="deal-card" onClick={() => nav(`/documentos/${c.id}`)} style={{ gridTemplateColumns: '1fr 220px auto' }}>
              <div>
                <div className="deal-card__code">{c.number}</div>
                <div className="deal-card__title" style={{ fontSize: 14 }}>{c.title ?? 'Contrato'}</div>
                <div className="deal-card__meta">{c.counterpartyName ?? '—'}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div className="row between" style={{ fontSize: 12 }}>
                  <span className="faint">Avance de cobro</span>
                  <span className="num" style={{ fontWeight: 600, color: pct === 100 ? 'var(--accent)' : 'var(--ink)' }}>{pct}%</span>
                </div>
                <span className="credit__bar"><span className="credit__fill" style={{ width: `${pct}%` }} /></span>
                <span className="num faint" style={{ fontSize: 11 }}>{money(c.paidMinor, c.currency)} / {money(c.totalMinor, c.currency)}</span>
              </div>
              <span className={`pill pill--${docStatusTone(c.status)}`} style={{ alignSelf: 'center' }}><span className="pill__dot" />{c.statusLabel}</span>
            </button>
          );
        })}
      </div>
    </main>
  );
}
